import { render, staticRenderFns } from "./CollectionJobStates.vue?vue&type=template&id=ca7d5dc2&"
import script from "./CollectionJobStates.vue?vue&type=script&lang=js&"
export * from "./CollectionJobStates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports